module.exports = __webpack_public_path__ + "../front/img/368hylde+3skuffer+trådkurv_lav.32007f63.svg";